// Per-region "additional columns" ride on each row's `metadata` under this key,
// as `{ [column_key]: value }`. The pipeline writes them
// (`merge_additional_column_into_metadata`); the tables render whichever ones
// the backend's additional-column configs list. This module is a leaf so both
// the table layer and the result types can read a value without a cycle.
export const ADDITIONAL_COLUMNS_METADATA_KEY = "additional_columns";

export interface RowWithMetadata {
    metadata?: { [key: string]: unknown } | null;
}

export const readAdditionalColumnValue = (
    metadata: RowWithMetadata["metadata"],
    columnKey: string
): unknown => {
    if (!metadata) return null;
    const additional = metadata[ADDITIONAL_COLUMNS_METADATA_KEY];
    if (
        !additional ||
        typeof additional !== "object" ||
        Array.isArray(additional)
    ) {
        return null;
    }
    // Narrowed to a non-array object above; index it as a plain record.
    const value = (additional as Record<string, unknown>)[columnKey];
    return value === undefined ? null : value;
};
